export default class ScrollLockController extends Classy {
  constructor(el) {
    super();
    // this.body = document.querySelector('html');
    this.element = el || document.body;
    this.y = 0;
    this.locked = false;
  }
  lock() {
    this.y = window.scrollY;
    this.locked = true;
    this.element.style.position = 'fixed';
    this.element.style.top = `-${this.y}px`;
    this.element.style.width = '100%';
    this.callback('lock');
  }
  unlock() {
    this.locked = false;
    this.element.style.position = '';
    this.element.style.top = '';
    this.element.style.width = '';
    window.scrollTo(0, this.y);
    this.callback('unlock');
  }
}